import { CircleUserRound, Database, PanelsTopLeft, Workflow, type LucideIcon } from 'lucide-react'

export interface NavItem {
  icon: LucideIcon
  sidebarLabelKey: string
  topbarLabelKey: string
  path: string
  disabled?: boolean
  /** Additional route prefixes that should keep this nav item highlighted */
  childPaths?: string[]
}

export const NAV_ITEMS: NavItem[] = [
  { icon: PanelsTopLeft, sidebarLabelKey: 'nav:menu.intelligent_board', topbarLabelKey: 'nav:menu.intelligent_board', path: '/intelligent-board' },
  { icon: Database, sidebarLabelKey: 'nav:menu.data', topbarLabelKey: 'nav:menu.data', path: '/data-catalog', childPaths: ['/document', '/graph-editor', '/datasheet', '/timeseries', '/video', '/data/graph', '/knowledge-graph', '/tag-mapping', '/human-expert-knowledge', '/connectors', '/plc-parser'] },
  { icon: CircleUserRound, sidebarLabelKey: 'nav:menu.digital_coworker', topbarLabelKey: 'nav:menu.digital_coworker', path: '/digital-coworker' },
  { icon: Workflow, sidebarLabelKey: 'nav:menu.workflow', topbarLabelKey: 'nav:menu.workflow', path: '/workflow' },
]
